<div class="tab-content" fxFlex="100%" fxLayout="row wrap">
  <p *ngIf="title" class="tab-title" fxFlex="100%" fxHide.mm-mobile="true">
    {{ title }}
  </p>
  <ng-container *ngIf="!isSellerModel; else info">
    <div
      *ngIf="tabId === takeBackInformation"
      class="tab-column"
      fxFlex="1 1 50%"
      fxFlex.mm-mobile="1 1 100%"
      fxFlex.mm-tablet="1 1 100%"
    >
      <div class="tab-column__item" fxLayout="row nowrap" fxLayoutAlign="flex-start">
        <div><mm-icon name="returns"></mm-icon></div>
        <p>
          {{ 'SELLER.SELLER_PAGE.TAKEBACKINFORMATION_FIELD.LABEL' | translate }}
          {{ content }}
        </p>
      </div>
    </div>
    <div *ngIf="tabId === allProducts" class="tab-column" fxFlex="1 1 100%">
      <div class="tab-column__item">
        {{ 'SELLER.SELLER_PAGE.ALL_PRODUCTS_INFO' | translate }}
      </div>
      <div class="tab-column__item button-container" fxLayout="row nowrap" fxLayoutAlign="flex-start">
        <a [href]="searchCatalogURL" class="tab-column__item--link">
          {{ 'SELLER.SELLER_PAGE.ALL_PRODUCTS_BUTTON' | translate }}
        </a>
      </div>
    </div>
    <div
      *ngIf="tabId !== takeBackInformation && tabId !== allProducts"
      [innerHtml]="content"
      class="tab-column"
      fxFlex="1 1 100%"
    ></div>
  </ng-container>
</div>

<ng-template #info>
  <div class="tab-column" fxFlex="1 1 50%" fxFlex.mm-mobile="1 1 100%" fxFlex.mm-tablet="1 1 100%">
    <div
      *ngIf="content?.addressLine || content?.addressLine2"
      class="tab-column__item"
      fxLayout="row nowrap"
      fxLayoutAlign="flex-start"
    >
      <div><mm-icon name="house"></mm-icon></div>
      <div>
        <p>
          {{ 'SELLER.SELLER_PAGE.ADDRESS_FIELD.LABEL' | translate }}
          <span *ngIf="content?.country">{{ content.country }}</span>
          <span *ngIf="content?.city">{{ content.city }}</span>
          <span *ngIf="content?.addressLine">{{ content.addressLine }}</span>
          <span *ngIf="content?.addressLine2">{{ content.addressLine2 }}</span>
          <span *ngIf="content?.zipCode">{{ content.zipCode }}</span>
          <span *ngIf="content?.headquarterEmail">{{ content.headquarterEmail }}</span>
          <span *ngIf="content?.headquarterPhone"
            ><a [href]="'tel:' + content?.headquarterPhoneCode + content?.headquarterPhone">
              {{ content.headquarterPhoneCode }} {{ content.headquarterPhone }}
            </a></span
          >
        </p>
      </div>
    </div>

    <div *ngIf="content?.phone" class="tab-column__item" fxLayout="row nowrap" fxLayoutAlign="flex-start">
      <div><mm-icon name="phone"></mm-icon></div>
      <p>{{ 'SELLER.SELLER_PAGE.PHONE_FIELD.LABEL' | translate }}</p>
      <a [href]="'tel:' + content?.phoneCode + content?.phone"> {{ content?.phoneCode }} {{ content?.phone }} </a>
    </div>
    <div *ngIf="content?.email" class="tab-column__item" fxLayout="row nowrap" fxLayoutAlign="flex-start">
      <div><mm-icon name="mail"></mm-icon></div>
      <p>{{ 'SELLER.SELLER_PAGE.EMAIL_FIELD.LABEL' | translate }}</p>
      <a [href]="'mailto:' + content?.email"> {{ content?.email }} </a>
    </div>
    <div *ngIf="content?.fax" class="tab-column__item" fxLayout="row nowrap" fxLayoutAlign="flex-start">
      <div><mm-icon name="phone"></mm-icon></div>
      <p>{{ 'SELLER.SELLER_PAGE.FAX_FIELD.LABEL' | translate }}</p>
      <a [href]="'tel:' + content?.faxCode + content?.fax">
        {{ content?.faxCode + content?.fax }}
      </a>
    </div>
  </div>

  <div class="tab-column" fxFlex="1 1 50%" fxFlex.mm-mobile="1 1 100%" fxFlex.mm-tablet="1 1 100%">
    <div *ngIf="content?.companyName" class="tab-column__item" fxLayout="row nowrap" fxLayoutAlign="flex-start">
      <div><mm-icon name="business"></mm-icon></div>
      <p>
        {{ 'SELLER.SELLER_PAGE.COMPANY_FIELD.LABEL' | translate }}
        {{ content.companyName }} {{ content?.legalForm }}
      </p>
    </div>

    <div *ngIf="content?.companyRegister" class="tab-column__item" fxLayout="row nowrap" fxLayoutAlign="flex-start">
      <div><mm-icon name="shopping-cart"></mm-icon></div>
      <p>
        {{ 'SELLER.SELLER_PAGE.TRADE_FIELD.LABEL' | translate }}
        {{ content?.companyRegister }}
      </p>
    </div>

    <div *ngIf="content?.taxId" class="tab-column__item" fxLayout="row nowrap" fxLayoutAlign="flex-start">
      <div><mm-icon name="advantages"></mm-icon></div>
      <p>
        {{ 'SELLER.SELLER_PAGE.VAT_FIELD.LABEL' | translate }}
        {{ content?.taxId }}
      </p>
    </div>

    <div
      *ngIf="content?.companyRepresentatives"
      class="tab-column__item"
      fxLayout="row nowrap"
      fxLayoutAlign="flex-start"
    >
      <div><mm-icon class="fluid" name="group"></mm-icon></div>
      <p>
        {{ 'SELLER.SELLER_PAGE.COMPANY_REPRESENTATIVES.LABEL' | translate }}
        <span *ngFor="let person of content?.companyRepresentatives">
          {{ person.firstName }} {{ person.lastName }}
        </span>
      </p>
    </div>

    <div
      *ngIf="content?.supervisoryAuthority"
      class="tab-column__item"
      fxLayout="row nowrap"
      fxLayoutAlign="flex-start"
    >
      <div><mm-icon name="business"></mm-icon></div>
      <p>
        {{ 'SELLER.SELLER_PAGE.SUPERVISORYAUTHORITY_FIELD.LABEL' | translate }}
        {{ content?.supervisoryAuthority }}
      </p>
    </div>

    <div
      *ngIf="content?.weeeRegistrationNumber"
      class="tab-column__item"
      fxLayout="row nowrap"
      fxLayoutAlign="flex-start"
    >
      <div><mm-icon name="business"></mm-icon></div>
      <p>
        {{ 'SELLER.SELLER_PAGE.WEEEREGNUM_FIELD.LABEL' | translate }}
        {{ content?.weeeRegistrationNumber }}
      </p>
    </div>

    <div
      *ngIf="content?.additionalInformation"
      class="tab-column__item"
      fxLayout="row nowrap"
      fxLayoutAlign="flex-start"
    >
      <div><mm-icon name="business"></mm-icon></div>
      <p>
        {{ 'SELLER.SELLER_PAGE.ADDITIONALINFORMATION_FIELD.LABEL' | translate }}
        <span [innerHTML]="content?.additionalInformation | linkify | sanitize"></span>
      </p>
    </div>

    <div *ngIf="content?.selfCertified" class="tab-column__item" fxLayout="row nowrap" fxLayoutAlign="flex-start">
      <div><mm-icon name="certificate-small"></mm-icon></div>
      <p>
        {{ 'SELLER.SELLER_PAGE.SELF_CERTIFICATION_FIELD.LABEL' | translate }}
      </p>
    </div>

    <div class="tab-column__item button-container" fxLayout="row nowrap" fxLayoutAlign="flex-start">
      <a [routerLink]="supportLink" class="tab-column__item--link">
        {{ 'SELLER.SELLER_PAGE.CONTACT_BUTTON' | translate }}
      </a>
    </div>
  </div>
</ng-template>
